module.exports = __webpack_public_path__ + "contact_mail_icon.6a70382defc9f421da97.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/share/contact_mail_icon.svg
// module id = 448
// module chunks = 0